export default __webpack_public_path__ + "static/media/image 30.5a773429.png";